import { apiClient } from '../../../api/client';
import { handleApiError } from '../../../api/errorHandler';

import { GetDeviceRequest, GetDeviceResponse } from './types';

export const getDevice = async (params: GetDeviceRequest): Promise<GetDeviceResponse> => {
  try {
    const response = await apiClient.get<GetDeviceResponse>(`/devices/${params.deviceId}/`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
